<!--
  Flexi module shell: identity, tab strip, active tab.

  The two redesigned tabs (General and HMS-status) bring their own cards, so
  the shell hands them a plain canvas. Every other tab still renders inside the
  legacy white panel it was built for — see `isFlatTab` in flexi.component.ts.
-->
<div class="flexi-shell">

  <header class="flexi-shell__head">
    <h1 class="flexi-shell__title">
      <span *ngIf="!isMedi3" translate>FLEXI</span>
      <span *ngIf="isMedi3" translate>BHT</span>
    </h1>
    <span class="flexi-shell__business" *ngIf="businessName">{{ businessName }}</span>
  </header>

  <ecpl-tab-navigation
    *ngIf="!isAdminMode"
    class="flexi-shell__tabs"
    [linkItems]="enabledAdditionalFeatures"
    [parentId]="fId"
  ></ecpl-tab-navigation>

  <!-- Admin mode: application-wide tabs, drawn as the design's underlined strip. -->
  <nav class="flexi-shell__admin-tabs" *ngIf="isAdminMode" [attr.aria-label]="'FLEXI' | translate">
    <a
      *ngFor="let tab of enabledAdditionalFeatures"
      class="flexi-shell__admin-tab"
      [routerLink]="[tab.linkText]"
      routerLinkActive="flexi-shell__admin-tab--active"
      ariaCurrentWhenActive="page"
    >{{ tab.translationKey | translate }}</a>
  </nav>

  <div *ngIf="safetyRoundNavigating" class="flexi-shell__route-status" role="status">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    {{ 'FLEXI_SAFETY_ROUNDS.FEEDBACK.NAVIGATING' | translate }}
  </div>
  <section
    [attr.aria-busy]="safetyRoundNavigating"
    [attr.inert]="safetyRoundNavigating ? '' : null"
    class="flexi-shell__body"
    [class.flexi-shell__body--flat]="isFlatTab"
    [class.flexi-shell__body--panel]="!isFlatTab"
  >
    <router-outlet></router-outlet>
  </section>
</div>
